import { render, staticRenderFns } from "./PaymentStatusLabel.vue?vue&type=template&id=16ed8b52&"
import script from "./PaymentStatusLabel.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStatusLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports